import BentoBox from './bento-box';
import BentoCompartment from './bento-compartment';

export default BentoBox;
export { BentoCompartment };
